import lax from 'lax.js';

function initLax() {
  lax.init();

  lax.addDriver('scrollY', () => window.scrollY);
}

function initMoreThanDogsTestimonialModule() {
  lax.addElements('.more-than-dogs-testimonials__lax-icon', {
    scrollY: {
      translateY: [
        ['elCenterY-elHeight', 'elCenterY', 'elCenterY+elHeight'],
        ['-elHeight', 0, 'elHeight'],
      ],
    },
  });
}

function initCampaignTestimonialModule() {
  lax.addElements('.campaign-testimonials__lax-icon', {
    scrollY: {
      translateY: [
        ['elCenterY-elHeight', 'elCenterY', 'elCenterY+elHeight'],
        ['-elHeight', 0, 'elHeight'],
      ],
    },
  });
}

initLax();

setTimeout(initMoreThanDogsTestimonialModule, 1000);
setTimeout(initCampaignTestimonialModule, 1000);
